export default __webpack_public_path__ + "static/media/placeholder.aa7fefb7.png";